import React from 'react';
import 'twin.macro';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import request from '@teetsh/app/src/utils/request';
import { useTranslation } from 'react-i18next';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { CDN_TRASH_KEY } from '@teetsh/app/src/containers/UserSettings/Trash/CarnetsDeNotes/useCarnetsDeNotesTrash';
import { cdnKeys } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/keys';

export function useRestoreCarnetDeNote() {
  const { notifySuccess, notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['userSettings']);
  const { mutateAsync } = useMutation({
    mutationFn: ({
      id,
      schoolyearId,
      schoolId,
    }: {
      id: string;
      schoolyearId: string;
      schoolId: string;
    }) =>
      request(
        `/schoolyears/${schoolyearId}/schools/${schoolId}/carnets-de-notes/${id}/restore`,
        { method: 'PATCH' },
      ),
    onSuccess: (_, { id, schoolyearId, schoolId }) => {
      queryClient.invalidateQueries({
        queryKey: [CDN_TRASH_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: cdnKeys.cdnList(schoolyearId, schoolId),
      });
      notifySuccess({
        title: t('userSettings:restore.messages.success'),
        actions: (
          <ButtonLink
            outlined
            intent="success"
            to={`/annee-scolaire/${schoolyearId}/ecole/${schoolId}/carnets-de-notes/${id}`}
          >
            {t('userSettings:restore.messages.see')}
          </ButtonLink>
        ),
      });
    },
    onError: () => {
      notifyError({ title: t('userSettings:restore.messages.error') });
    },
  });
  return mutateAsync;
}
